import { type ReactNode, memo } from 'react'

import { cn } from '@/shared/lib/cn'
import { Button } from '@/shared/ui/Button.tsx'

import { FeatureTooltipInfo } from '../types/FeatureTooltipInfo.ts'
import { FeatureIcon, type FeatureIconProps } from './FeatureIcon.tsx'
import { FeatureTooltipByTooltipInfo } from './FeatureTooltipByTooltipInfo.tsx'

interface FeatureClickableButtonProps {
	ref?: React.Ref<HTMLParagraphElement>
	iconValues: FeatureIconProps
	isExist?: boolean
	onClick?: () => void
	disableIcon?: boolean
	tooltipInfo: FeatureTooltipInfo
	children: ReactNode
	classNames?: {
		base?: string
		container?: string
		tooltip?: string
	}
}

export const FeatureClickableButton = memo(
	({
		ref,
		iconValues,
		isExist,
		onClick,
		disableIcon,
		tooltipInfo,
		children,
		classNames
	}: FeatureClickableButtonProps) => {
		return (
			<div className={cn('flex h-full gap-2', classNames?.container)}>
				<Button
					className={cn(
						'text flex h-auto gap-x-3 px-0 py-0 whitespace-normal decoration-1 hover:bg-none',
						classNames?.base
					)}
					variant="link"
					onClick={onClick}
				>
					{!disableIcon && (
						<FeatureIcon
							className={cn(
								'min-h-6 min-w-6',
								isExist ? 'text-gray-500' : 'text-brand-100'
							)}
							{...iconValues}
						/>
					)}

					<span ref={ref}>{children}</span>
				</Button>

				<FeatureTooltipByTooltipInfo
					className={classNames?.tooltip}
					iconValues={iconValues}
					tooltipInfo={tooltipInfo}
					isExist={isExist}
				/>
			</div>
		)
	}
)

FeatureClickableButton.displayName = 'FeatureClickableButton'
